"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {assetPath} from "@/shared/utils/asset-path";

import "./styles/button-like.scss";

type LikeActionsProps = {
    likes?: number;
    dislikes?: number;
    onLikeClick?: () => void;
    onDislikeClick?: () => void;
};

export function ButtonLike({likes = 0, dislikes = 0, onLikeClick, onDislikeClick}: LikeActionsProps): JSX.Element {
    return (
        <div className="like-actions">
            <button type="button" className={`info-card__action-btn info-card__action-btn--like`} onClick={onLikeClick} aria-label="Like">
                <SmartImage src={assetPath("/images/icons/like.svg")} alt="Like" width={16} height={16} />
                <span>{likes}</span>
            </button>
            <button type="button" className={`info-card__action-btn info-card__action-btn--dislike`} onClick={onDislikeClick} aria-label="Dislike">
                <SmartImage src={assetPath("/images/icons/like.svg")} alt="Dislike" width={16} height={16} style={{transform: "rotate(180deg)"}} />
                <span>{dislikes}</span>
            </button>
        </div>
    );
}
